var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxioneRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12300_2257)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 19,
    rx: 9,
    fill: "url(#paint0_linear_12300_2257)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12300_2257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4835 10.9498C5.4835 8.59267 6.85235 7.32487 8.99147 7.32487C11.1476 7.32487 12.5166 8.59283 12.5166 10.9498C12.5166 13.3068 11.1476 14.5749 8.99147 14.5749C6.85245 14.5749 5.4835 13.3071 5.4835 10.9498ZM8.99147 6.19995C6.1165 6.19995 4.19995 7.98555 4.19995 10.9498C4.19995 13.9141 6.1165 15.7 8.99147 15.7C11.8834 15.7 13.8 13.9141 13.8 10.9498C13.8 7.98555 11.8834 6.19995 8.99147 6.19995Z",
    fill: "url(#paint1_linear_12300_2257)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12300_2257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4835 21.0833C5.4835 18.7261 6.85235 17.4583 8.99147 17.4583C11.1476 17.4583 12.5166 18.7263 12.5166 21.0833C12.5166 23.4403 11.1476 24.7083 8.99147 24.7083C6.85245 24.7083 5.4835 23.4405 5.4835 21.0833ZM8.99147 16.3334C6.1165 16.3334 4.19995 18.119 4.19995 21.0833C4.19995 24.0475 6.1165 25.8334 8.99147 25.8334C11.8834 25.8334 13.8 24.0475 13.8 21.0833C13.8 18.119 11.8834 16.3334 8.99147 16.3334Z",
    fill: "url(#paint2_linear_12300_2257)",
    shapeRendering: "crispEdges"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 17,
    height: 18,
    rx: 8.5,
    stroke: "#F3F4F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12300_2257",
    x: 3.19995,
    y: 6.19995,
    width: 11.6001,
    height: 11.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945199 0 0 0 0 0.945199 0 0 0 0 0.945199 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12300_2257"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12300_2257",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12300_2257",
    x: 3.19995,
    y: 16.3334,
    width: 11.6001,
    height: 11.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945199 0 0 0 0 0.945199 0 0 0 0 0.945199 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12300_2257"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12300_2257",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12300_2257",
    x1: 9,
    y1: 10,
    x2: -0.593237,
    y2: 21.2089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12300_2257",
    x1: 11.7,
    y1: 6.19995,
    x2: 3.63203,
    y2: 11.4915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EDA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EDA6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12300_2257",
    x1: 8.99995,
    y1: 25.8334,
    x2: 8.99995,
    y2: 16.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.718577,
    stopColor: "#00EDA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EDA6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12300_2257"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 19,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxioneRound);
export default __webpack_public_path__ + "static/media/axione-round.6bb3450219616da29e0248caa7ce91e7.svg";
export { ForwardRef as ReactComponent };